import React from 'react';
import { FormattedMessage } from 'react-intl';

const ReopenEvent = () => {
    return <FormattedMessage id={'corrective_actions.events.reopen'} />
}

export default ReopenEvent;